import { render, staticRenderFns } from "./activityFeed.vue?vue&type=template&id=21c8fb80"
import script from "./activityFeed.vue?vue&type=script&lang=js"
export * from "./activityFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports